angular.module('routes.reports.ReportsController', [
  'stack'
])

/**
 * The ReportsController manages view logic rendered to the
 * reports.html template for the /reports reports.
 *
 * @class ReportsController
 * @constructor
 * @module routes.reports.ReportsController
 */
.controller('ReportsController', [
  '$scope',
  '$rootScope',
  '$state',
  '$window',
  '$timeout',
  '$location',
  'ModelsService',
  'ReportsService',
  'ThemesService',
  'PaginationService',
  'GLOBAL',
  function ($scope,
    $rootScope,
    $state,
    $window,
    $timeout,
    $location,
    ModelsService,
    ReportsService,
    ThemesService,
    PaginationService,
    GLOBAL) {
    'use strict';

    $scope.Math = Math;

    /**
     * Property houses controller namespace.
     *
     * @property reports
     * @type {Object}
     */
    $scope.reports = {
      list: [],
      current: null,
      constants: {}
    };

    $scope.view = {
      tab: 1,
      screen: 'cases',
      loading: true,
      loadingdetails: true
    };

    $scope.casesCSVlabel = 'course-metrics';

    $scope.user = $rootScope.user;

    $scope.state = $state;

    $scope.print = function () {
      $window.print();
    };

    $scope.setActive = function (index) {
      $scope.activeTab[index] = true;
    };

    $scope.dateformat = function (dt) {
      return moment(dt).format('MM.DD.YYYY@HH:mm');
    };

    /**
     * opens report in new window, with the access token from the url if it exists
     *
     * @param {string} id - report id
     */
    $scope.showReport = function (id) {
      $window.open($state.href('routes.reports', { reportId: id }) + '#' + $location.hash());
    };

    $scope.filterReportsStudentCase = function (studentId, caseId) {
      _.forEach($scope.reports.filters['content.user'], function (uf) {
        if (uf.id === studentId) {
          uf.on = true;
        } else {
          uf.on = false;
        }
      });

      _.forEach($scope.reports.filters['content.simulation'], function (cf) {
        if (cf.id === caseId) {
          cf.on = true;
        } else {
          cf.on = false;
        }
      });

      $scope.view.tab = 2;
      $timeout(function () {
        $scope.reports.filterPages();
      });
    };

    $scope.backToCaseList = function () {
      $scope.view.screen = 'cases';
    };

    $scope.caseReport = function (reportedCase) {
      $scope.view.loading = true;
      ModelsService.get(
        'cases',
        GLOBAL.apiPath + '/cases/' + reportedCase.id,
        true,
        500000
      )
      .then(function (response) {
        $scope.currentCase = response;
        $scope.view.screen = 'case';
        $scope.view.loading = false;
        ReportsService.getCaseQuestions($scope.currentCase, reportedCase.reports, true)
        .then(function () {
          $scope.view.loadingdetails = false;
          return true;
        }).catch();
        return true;
      })
      .catch();
    };

    function initReports() {
      ModelsService.empty('reports');
      ModelsService.initialize(
          'reports',
          GLOBAL.apiPath + '/reports?limit=2000',
          500000
        )
        .then(function () {
          PaginationService.updateFullSet('reports', ['contextId', 'content.simulation', 'content.user']);
          $scope.reportedCases = ReportsService.getCases();

          $timeout(function () {
            $scope.reports.filterPages();
          });
          $scope.view.loading = false;

          return true;
        }).catch(function () {
          return false;
        });
    }

    /**
     * Method sets the report data via model
     *
     * @private
     */
    function defineReports() {
      if ($state.params.reportId) {
        $scope.reports.current = ReportsService
          .formatReports($rootScope.report);
        $rootScope.report = $scope.reports.current;
      } else {
        PaginationService.paginate(
          'reports',
          GLOBAL.apiPath + '/reports',
          {
            limit: 10,
            perpage: 50
          })
        .then(function () {
          $scope.reports = PaginationService.get('reports');
          initReports();
          return true;
        }).catch();
      }
    }

    /**
     * Defines the current theme
     */
    function defineTheme() {
      var themeString = 'nursing';
      $scope.theme = {};
      if ($scope.reports.current) {
        themeString = $scope.reports.current.content.simulation.theme;
      }
      ThemesService
        .getThemeConfig(themeString)
        .then(function (theme) {
          $scope.theme = theme.data;
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      defineReports();
      defineTheme();
    }
    initialize();
  }
]);
